<template>
  <div class="taskbar">
    <div class="brand">

    </div>
    <div class="taskbar-content">
      <a href="https://www.wonglok.com" class="logo"></a>
      <div class="taskbar-icon home" @click="goSRN">
        SRN 💖
      </div>
      <div class="taskbar-icon button3d" v-if="$server.portal.meta.space3DMode" @click="toggle3DSpace">
        2D 🎩
      </div>
      <div class="taskbar-icon button3d" v-if="!$server.portal.meta.space3DMode" @click="toggle3DSpace">
        3D 🎩
      </div>
      <div class="taskbar-icon adder" @click="$server.portal.addWindow({ type: 'quotes' })">
        Quotes +
      </div>
      <div class="taskbar-icon adder" @click="$server.portal.addWindow({ type: 'animation' })">
        Roll +
      </div>
      <div class="taskbar-icon adder" @click="$server.portal.addWindow({ type: 'dimensional' })">
        Space +
      </div>
      <div class="taskbar-icon adder" @click="$server.portal.addWindow({ type: 'particle-sea' })">
        Sea +
      </div>
      <div class="taskbar-icon adder" @click="$server.portal.addWindow({ type: 'volumetric' })">
        Volume +
      </div>
      <div
      class="taskbar-icon win" :key="ipk"
      :class="{ 'is-on': ip.win.minimised }"
      v-for="(ip, ipk) in $server.portal.portals.slice().sort((a, b) => { return a.date - b.date })"

        @mouseenter="$emit('activated', { portal: ip })"
        @touchstart="$emit('activated', { portal: ip })"
        @click="$emit('activated', { portal: ip })"
      >
        App {{ ipk + 1 }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted () {
    this.$forceUpdate()
  },
  data () {
    return {
      serv: this.server,
      toggle3D: false
    }
  },
  methods: {
    toggle3DSpace () {
      this.$server.portal.meta.space3DMode = !this.$server.portal.meta.space3DMode
    },
    goHome () {
      window.location.href = '/'
    },
    goSRN () {
      window.location.href = 'https://srn.net'
    }
  }
}
</script>

<style scoped>
.taskbar{
  position: absolute;
  bottom: 0px;
  left: 0px;
  width: 100%;
}

.taskbar-content{
  /* max-width: 960px; */
  margin-bottom: 20px;
  margin-left: 20px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.taskbar-icon{
  display: inline-block;
  /* height: calc(90px - 10px * 2);
  width: calc(90px - 10px * 2); */
  /* border: rgb(248, 194, 194) solid 1px; */
  padding: 10px;
  border-radius: 10px;
  margin: 0px 8px;
  margin-top: 10px;

  /* box-shadow: 0px 0px 50px 0px rgba(255, 255, 255, 0.623); */
  font-size: 13px;
  text-align: center;
  /* line-height: calc(90px - 10px * 2); */
  background-image: linear-gradient(9deg, #efd5ff 0%, #515ada 100%);
  color: white;
  background-size: 200% 200%;
  background-position: left bottom;
  transition: background-position 0.3s;
}

.adder{
  background-size: 200% 200%;
  background-image: linear-gradient(45deg, #00C9FF 0%, #92FE9D 100%);
}
.button3d{
  background-color: #8EC5FC;
  background-image: linear-gradient(62deg, #8EC5FC 0%, #E0C3FC 100%);
}
.home{
  background-color: #8EC5FC;
  background-image: linear-gradient(62deg, #8EC5FC 0%, #E0C3FC 100%);
}

.taskbar-icon:hover,
.taskbar-icon.adder:hover {
  background-position: right top;
}

.brand{
  cursor: pointer;

  position: absolute;

  bottom: 50px;
  right: 20px;

}
.logo{
  display: inline-block;
  width: 130px;
  height: 35px;
  background-size: contain;
  background-image: url(https://www.wonglok.com/_acs/www.wonglok.com/images/header-logo.png);
}

.is-on{
  position: relative;
}
.is-on::after{
  content: '';
  position: absolute;
  bottom: -13px;
  left: calc(50% - 10px / 2);
  width: 10px;
  height: 10px;
  background-color: rgb(36, 49, 228);
  box-shadow: 0px 0px 30px 0px rgb(53, 215, 255);
  border-radius: 50%;
  z-index: 1000000;
  animation: bg-color 1s ease 0s infinite alternate both;
}

@keyframes bg-color {
  0% {
    background-color: hsl(241, 100%, 50%);
  }
  100% {
    background-color: rgba(0, 217, 255, 0.986);
  }
}

</style>



// WEBPACK FOOTER //
// src/components/TaskBar/index.vue